module.exports = __webpack_public_path__ + "media/images/homepage/vector1-82733b83dbfa479839b6961063b10a20.png";